import config from "../config";
import { applyEnvConfig } from "~/util/envHelpers";
import { ServerContext } from "~/service/context-keeper/types";

const exportPlugin = (context: ServerContext) => {
    applyEnvConfig(config, context.$config);
};

export default exportPlugin;
